import { render, staticRenderFns } from "./prevGoods.vue?vue&type=template&id=f51c607e&scoped=true&"
import script from "./prevGoods.vue?vue&type=script&lang=js&"
export * from "./prevGoods.vue?vue&type=script&lang=js&"
import style0 from "./prevGoods.vue?vue&type=style&index=0&id=f51c607e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51c607e",
  null
  
)

export default component.exports